import React, { useRef, useCallback, } from 'react'
import List from '../../grid.component';
import { AddresssHandler, AmountHandler, CreditHandler, DateHandler, TransactionHash } from '../service';
import { useParams } from 'react-router-dom';


const TopUpTransactionsGrid = ((props) => {
    const gridRef = useRef(null);
    const { tenantId } = useParams()
    const handleHash = useCallback((data) => () => {
        window.open(data.url)
    }, [])
    const topupTransactionHandler = useCallback((data) => {
        return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
    }, [])
    const addressHandler = useCallback((data) => {
        return <AddresssHandler data={data?.dataItem} />
    }, [])
    const creditHandler = useCallback((data) => {
        return <CreditHandler data={data?.dataItem} />
    }, [])
    const dateHandler = useCallback((data) => {
        return <DateHandler data={data?.dataItem} />
    }, [])
    const amountHandler = useCallback((data) => {
        return <AmountHandler data={data?.dataItem} />
    }, [])

    const gridColumns = [
        {
            "field": "transactionhash",
            "title": "Transaction Hash",
            "filter": true,
            "customCell": topupTransactionHandler,
            "width": 200
        },
        {
            "field": "credits",
            "title": "Credit",
            "customCell": creditHandler,
            "filter": true,
            "width": 150,
            "filterType": "numeric"
        },
        {
            "field": "date",
            "title": "Date/Time",
            "filter": true,
            "width": 200,
            "filterType": "date",
            "customCell": dateHandler
        },
        {
            "field": "address",
            "title": "Address",
            "customCell": addressHandler,
            "filter": true,
            "width": 200
        },
        {
            "field": "currency",
            "title": "Currency",
            "filter": true,
            "width": 150
        },
        {
            "field": "amount",
            "title": "Amount",
            "customCell": amountHandler,
            "filter": true,
            "width": 150,
            "filterType": "numeric"
        }
    ]

    return (
        <div>
            <List
                url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/Topupk/${tenantId}`}
                pSize={10}
                additionalParams={props?.filterValues}
                gridRef={gridRef}
                className="custom-grid"
                screenName={'Energy_TopUp_Transactions'}
                showExcelExport={props?.isExcelExport}
                columns={gridColumns}
                pKey={"Energy_TopUp_Transactions"}
            />
        </div>
    )
})

export default React.memo(TopUpTransactionsGrid)
